import React, { useState } from "react";
import "./FeatureCard.css";
import { motion, AnimatePresence } from "framer-motion";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const FeatureCard = ({ icon, title, description, isMobile }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return !isMobile ? (
    <div className="feature-card-desktop">
      <div className="feature-title-desktop">
        <div className="feature-icon-desktop">{icon}</div>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  ) : (
    <div
      className={`feature-card ${isExpanded ? "expanded" : ""}`}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="feature-header">
        <div className="feature-title">
          <div className="feature-icon">{icon}</div>
          <h3>{title}</h3>
        </div>
        <motion.div
          className="expand-icon"
          initial={false}
          animate={{ rotate: isExpanded ? 180 : 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut",
          }}
        >
          <KeyboardArrowDownIcon />
        </motion.div>
      </div>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            className="feature-content"
            initial={{ height: 0, opacity: 0 }}
            animate={{
              height: "auto",
              opacity: 1,
              transition: {
                height: { duration: 0.2, ease: "easeOut" },
                opacity: { duration: 0.15, ease: "linear" },
              },
            }}
            exit={{
              height: 0,
              opacity: 0,
              transition: {
                height: { duration: 0.2, ease: "easeIn" },
                opacity: { duration: 0.1, ease: "linear" },
              },
            }}
          >
            <div className="feature-content-inner">
              <p>{description}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FeatureCard;
